module.exports = __webpack_public_path__ + "static/img/4.fa37036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/4.png
// module id = XCjK
// module chunks = 2